import { createBrowserRouter, Navigate } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { AppLayout } from "../layouts/AppLayout";
import { ForgotPasswordPage } from "../pages/ForgotPasswordPage";
import { LoginPage } from "../pages/LoginPage";
import { NotFoundPage } from "../pages/NotFoundPage";
import { OverviewPage } from "../pages/OverviewPage";
import { ProgrammesPage } from "../pages/ProgrammesPage";
import { FundingPage } from "../pages/FundingPage";
import { ResetPasswordPage } from "../pages/ResetPasswordPage";
import { DonorsPage } from "../pages/DonorsPage";
import { ScholarshipsPage } from "../pages/ScholarshipsPage";
import { ReportsPage } from "../pages/ReportsPage";
import { SettingsPage } from "../pages/SettingsPage";
import { TransactionsPage } from "../pages/TransactionsPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  { path: "/reset-password", element: <ResetPasswordPage /> },
  {
    path: "/",
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, element: <OverviewPage /> },
          { path: "transactions", element: <TransactionsPage /> },
          { path: "programmes", element: <ProgrammesPage /> },
          { path: "funding", element: <FundingPage /> },
          { path: "donors", element: <DonorsPage /> },
          { path: "scholarships", element: <ScholarshipsPage /> },
          { path: "reports", element: <ReportsPage /> },
          { path: "settings", element: <SettingsPage /> },
          { path: "404", element: <NotFoundPage /> },
          { path: "*", element: <Navigate to="/404" replace /> },
        ],
      },
    ],
  },
]);
